// extracted by mini-css-extract-plugin
export default {"category":"category_category__ll0Is","title":"category_title__-jVV3"};